import React from 'react';
import {useFormContext, Controller} from 'react-hook-form';
import Label from '../Label';

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    required?: boolean;
    name: string;
    label: string;
    size_label: string;
    size_input: string;
    remove_label?: boolean;
    data_tip?: string;
}

const InputLabelTextArea: React.FC<Props> = ({
    name,
    required,
    label,
    size_input,
    size_label,
    remove_label,
    data_tip,
    ...otherProps
}) => {
    const {
        control,
        formState: {errors},
        getValues
    } = useFormContext();

    return (
        <>
            {!remove_label && (
                <Label
                    required={required}
                    respAlt
                    title={label}
                    data_tip={data_tip}
                    col={`col-sm-${size_label}`}
                    to={name}
                />
            )}
            <div className={`col-sm-${size_input} resp-form`}>
                <Controller
                    name={`${name}`}
                    control={control}
                    render={({field}) => (
                        <textarea
                            className="form-control form-control-sm"
                            disabled={getValues('form_action') === 'view'}
                            {...otherProps}
                            {...field}
                        />
                    )}
                />
                {errors && errors[`${name}`] && (
                    <span className="span text-danger text-min-sm">
                        {errors[`${name}`].message}
                    </span>
                )}
            </div>
        </>
    );
};

export default InputLabelTextArea;
